import styled from '@emotion/styled';
import { Table, Tooltip } from 'antd';
import { orderBy } from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { FiRefreshCcw } from 'react-icons/fi';
import { PulseLoader } from 'react-spinners';
import { BondEntity } from '../../../../../entities/bond.entity';
import { PRIMARY, YELLOW } from '../../../../../shared/colors';
import { getMovers } from '../../../network';

const Container = styled.div`
  color: white;
  padding: 5px;
  margin-bottom: 5px;
  font-family: Poppins-R;

  td.ant-table-column-sort {
    background-color: transparent !important;
  }

  th {
    background-color: ${PRIMARY} !important;
    color: white !important;
    font-weight: bold;
  }

  .odd-row {
    background-color: #757575;
    color: white;
  }

  .even-row {
    background-color: #757575;
    color: white;
  }
`;

export const Movers = ({
  getBond,
}: {
  getBond: (b: BondEntity, ope: '1' | '2') => void;
}) => {
  const [movers, setMovers] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    setIsLoading(true);
    getMovers().then(({ data }) => {
      setMovers(orderBy(data, 'count', 'desc'));
      setIsLoading(false);
    });
  };

  return (
    <Container>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          paddingRight: 10,
        }}
      >
        <div style={{ marginRight: 150 }}>
          <PulseLoader size={5} margin={2} color={YELLOW} loading={isLoading} />
        </div>
        <Tooltip title='Rafraichir' placement='leftTop' color={YELLOW}>
          <span style={{ cursor: 'pointer' }} onClick={fetchData}>
            <FiRefreshCcw />
          </span>
        </Tooltip>
      </div>
      {movers.length === 0 ? (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          Aucun movers disponible ...
        </div>
      ) : (
        <Table
          columns={COLUMNS}
          dataSource={movers}
          rowSelection={{
            type: 'radio',
            onChange: (selectedRowKeys, selectedRows) => {
              getBond(selectedRows[0], '1');
            },
          }}
          rowClassName={(row, index) =>
            index % 2 === 0 ? 'even-row' : 'odd-row'
          }
          rowKey='id'
          size='small'
          style={{ zoom: 0.8 }}
          pagination={false}
          showSorterTooltip={false}
        />
      )}
    </Container>
  );
};

const COLUMNS = [
  {
    title: 'Pays',
    dataIndex: 'pays',
    sorter: (a: BondEntity, b: BondEntity) => a.pays.localeCompare(b.pays),
  },
  {
    title: 'Type',
    dataIndex: 'instrument',
    sorter: (a: BondEntity, b: BondEntity) =>
      a.instrument.localeCompare(b.instrument),
  },
  {
    title: 'CODE',
    dataIndex: 'code',
    sorter: (a: BondEntity, b: BondEntity) => a.code.localeCompare(b.code),
    render: (cell: any, row: BondEntity) => (
      <div
        style={{
          width: 120,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
      >
        {row.code}
      </div>
    ),
  },
  {
    title: 'Date de maturation',
    dataIndex: 'dateMaturite',
    render: (cell: any) => `${moment(cell).format('DD/MM/YYYY')}`,
    sorter: (a: BondEntity, b: BondEntity) =>
      a.dateMaturite.localeCompare(b.dateMaturite),
  },
  {
    title: 'Coupon',
    dataIndex: 'tauxMarginal',
    sorter: (a: BondEntity, b: BondEntity) => a.tauxMarginal - b.tauxMarginal,
    render: (cell: any, row: BondEntity) => <>{Number(row.tauxMarginal)}</>,
  },
  {
    title: 'Mover',
    dataIndex: 'count',
    sorter: (a: any, b: any) => a.count - b.count,
  },
];
